const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the Imported Content's host for ImportedContentRegistrations component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {ImportedContentRegistrations} ImportedContentRegistrations the resource defined to manage ImportedContentRegistrations
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('importedContentHostRegistrations', ['Application', 'ImportedContentRegistrations', 'Users', '$translate', function(Application, ImportedContentRegistrations, Users, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        vendor: '@'
      },
      template: require('../../templates/directives/imported-content-host-registrations.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          var params = Application.navigation.getRouteParameters();

          self.translations = {};

          self.sortName = 'createdAt';
          self.sortOrder = -1;
          self.contentId = params.id;

          self.getProgress = function(amnt) {
            if (amnt !== 'unknown') {
              var style = {
                'width': amnt + '%'
              };
              return style;
            }
            ;
          };
          self.filter = {
            subresource: self.contentId,
            page: null,
            per_page: 20,
            'user-populate': 'first_name,last_name,email,image,linked_locations,linked_departments',
            'user.linked_locations-populate': 'name',
            'user.linked_departments-populate': 'name',
            'content-populate': 'title,description,archived,createdAt',
            fields: 'company,user,content,results,createdAt,completed,completed_date',
            sort: self.sortName + ',' + self.sortOrder
          };
          self.goToUser = function(user) {
            if (!user || !user._id) {
              return;
            }
            Application.navigation.goTo('/edit/users/' + user._id);
          };

          self.nextPage = function() {
            if (!self.filter.page) {
              self.filter.page = 0;
            }
            self.filter.page++;
            self.loadItems();
          };
          self.previousPage = function() {
            if (!self.filter.page || self.filter.page < 2) {
              self.filter.page = 2;
            }
            self.filter.page--;
            self.loadItems();
          };
          self.getLocation = function(user) {
            if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
              return user.linked_locations[0].name;
            }
            return '-----';
          };
          self.getDepartment = function(user) {
            if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
              return user.linked_departments[0].name;
            }
            return '-----';
          };

          self.loadItems = function() {
            self.searchLoading = true;
            ImportedContentRegistrations.find(self.filter).$promise.then(function(items) {
              self.allowNext = true;
              self.allowPrevious = true;
              items.forEach(function(item) {
                item.passed_failed_status = 'unknown';
                item.seconds_spent = '';
                item.score = 'unknown';
                item.progress = 'unknown';
                item.timestamp = null;
                if (!item.results || item.results.length === 0) {
                  return;
                }
                var latest_progress = item.results.find(function(result) {
                  return result.name === 'latest_progress';
                });
                if (!latest_progress) {
                  return;
                }
                latest_progress.object = JSON.parse(latest_progress.value);
                latest_progress.object = JSON.parse(latest_progress.value);
                item.passed_failed_status = 'unknown';
                item.completed = item.completed || (latest_progress.object.course_completion_date || parseInt(latest_progress.object.completion_ratio) === 100) ? true : false;
                if (item.completed && !item.completed_date) {
                  item.completed_date = moment(latest_progress.object.course_completion_date).local() ? new Date(latest_progress.object.course_completion_date) : new Date();
                }
                item.passed_failed_status = 'unknown';
                item.score = 'unknown';
                item.seconds_spent = latest_progress.object.num_video_consumed_minutes ? parseInt(latest_progress.object.num_video_consumed_minutes * 60) : -1;
                item.progress = latest_progress.object.completion_ratio;
              });
              if (items.length < self.filter.per_page) {
                self.allowNext = false;
              }
              if (self.filter.page < 2) {
                self.allowPrevious = false;
              }
              self.registrations = items;
              self.searchLoading = false;
            });
          };
          self.slimDate = function(date, yyyyMMddhhmmss) {
            if (yyyyMMddhhmmss) {
              moment(date, 'YYYYMMDDhhmmss').format('D-MMM-YYYY h:mm a');
            }
            return moment(new Date(date)).format('D-MMM-YYYY h:mm a');
          };
          self.timeSpent = function(seconds_spent) {
            var seconds = parseInt(seconds_spent, 10);

            var days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;
            var hrs = Math.floor(seconds / 3600);
            seconds -= hrs * 3600;
            var mnts = Math.floor(seconds / 60);
            seconds -= mnts * 60;
            if (days > 0) {
              return days + "d " + hrs + "h " + mnts + "m " + seconds + "s";
            }
            if (hrs > 0) {
              return hrs + "h " + mnts + "m " + seconds + "s";
            }
            if (mnts > 0) {
              return mnts + "m " + seconds + "s";
            }
            return seconds + "s";
          };
          self.changeSort = function(name) {
            self.filter.page = 0;
            if (self.sortName !== name) {
              self.sortOrder = -1;
            }
            if (self.sortName === name) {
              self.sortOrder = self.sortOrder * -1;
            }
            self.sortName = name;
            self.filter.sort = self.sortName + ',' + self.sortOrder;
            self.nextPage();
          };
          self.initialize = function() {
            if (!self.contentId) {
              Application.navigation.goToHome();
              return;
            }
            self.registrations = [];
            self.nextPage();
          };

          self.userDirectory = {};
          self.smart_filter = {};
          self.selectionDirectory = {};
          self.selections = {
            select: function(item) {
              var id = item._id;
              if (self.selectionDirectory[id]) {
                delete self.selectionDirectory[id];
              } else {
                self.selectionDirectory[id] = item;
              }

              var ids = [];
              for (var id in self.selectionDirectory) {
                ids.push(self.selectionDirectory[id]._id.toString());
              }
              self.searchItems.csv_selected += '&users=$in,' + ids.length + ',' + ids.join(',');
            },
            isChecked: function(item) {
              if (!item || !item._id) {
                return false;
              }
              return self.selectionDirectory[item._id] ? true : false;
            },
            clear: function() {
              self.selectionDirectory = {};
            }
          };
          self.searchItems = {
            placeholder: self.translations['importedContentHostRegistrations.search_placeholder'],
            onQuery: function(query_arguments) {
              self.smart_filter = {};
              self.searching = false;
              if (query_arguments && typeof query_arguments === 'object' && Object.keys(query_arguments).length) {
                self.searching = true;
              }
              if (!query_arguments || (typeof query_arguments === 'object' && Object.keys(query_arguments).length === 0)) {
                self.filter = {
                  subresource: self.contentId,
                  page: 1,
                  per_page: 20,
                  'user-populate': 'first_name,last_name,email,image,linked_locations,linked_departments',
                  'user.linked_locations-populate': 'name',
                  'user.linked_departments-populate': 'name',
                  'content-populate': 'title,description,archived,createdAt',
                  fields: 'company,user,content,results,createdAt',
                  sort: self.sortName + ',' + self.sortOrder
                };
                self.loadItems();
                return;
              }

              for (var key in query_arguments) {
                self.smart_filter[key] = query_arguments[key];
              }
              var user_filter = {
                fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
                'linked_locations-populate': 'name',
                'linked_departments-populate': 'name',
                page: 1,
                per_page: 50
              };
              if (self.smart_filter.privacy_locations) {
                user_filter.linked_locations = self.smart_filter.privacy_locations;
              }
              if (self.smart_filter.privacy_departments) {
                user_filter.linked_departments = self.smart_filter.privacy_departments;
              }
              if (self.smart_filter.privacy_teams) {
                user_filter.linked_teams = self.smart_filter.privacy_teams;
              }
              if (self.smart_filter.privacy_org_level) {
                user_filter.linked_org_level = self.smart_filter.privacy_org_level;
              }
              if (self.smart_filter.privacy_grade) {
                user_filter.linked_grade = self.smart_filter.privacy_grade;
              }
              if (self.smart_filter.groups) {
                user_filter.groups = self.smart_filter.groups;
              }
              if (self.smart_filter.name) {
                user_filter.full_name = self.smart_filter.name;
              }
              if (self.smart_filter.$or) {
                user_filter.$or = self.smart_filter.$or;
              }
              self.searching = true;
              self.searchLoading = true;
              Users.find(user_filter).$promise.then(function(users) {
                var ids = users.map(function(user) {
                  self.userDirectory[user._id] = user;
                  return user._id;
                });
                var length = ids.length;
                ids = ids.join(',');

                self.filter.page = 1;
                self.filter.user = '$in,' + length + ',' + ids;
                self.loadItems();
              });
            },
            csv_filtered: '',
            csv_selected: ''
          };
          self.initialize();

          $translate([
            'importedContentHostRegistrations.search_placeholder'
          ]).then(function (translations) {
            self.translations = translations;
          })

        }],
      controllerAs: 'hostRegistrations'
    };
  }]);
